import Page from "@jumbo/shared/Page";
import AuthenticateAndRolesMiddleware from "../Middleware";
import ListPurchaseOrders from "app/pages/PurchaseOrder/ListPurchaseOrder";
import AddEditPurchaseOrder from "app/pages/PurchaseOrder/AddEditPurchaseOrder";


const routesName = "/dashboards/purchaseOrder";
const modules = "ssk_po";

export const purchaseOrderRoute = [
  {
    middleware: [
      {
        element: AuthenticateAndRolesMiddleware,
        fallbackPath: "/login",
        module: modules
      },
    ],
    routes: [
      {
        path: `${routesName}`,
        element: <Page component={ListPurchaseOrders} />
      },
      {
        path: `${routesName}/add`,
        element: <Page component={AddEditPurchaseOrder} />,
      },
      {
        path: `${routesName}/edit`,
        // element: <Page component={EditCloudstratClient} />,
      },
    ],
  },]
